import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';

export class GridActionsReducer {

    /**
     * @param {string} key
     * @param {*} value
     * @memberof GridActionsReducer
     */
    public storeViewModel(key: string, value: any, selectedTemplateName: string, actionType: string) {
        let ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(selectedTemplateName, 'ruleElements');
        if (ruleElements.hasOwnProperty('gridObject')) {
            let gridObject = { ...ruleElements.gridObject };
            if (gridObject.hasOwnProperty(actionType)) {
                let actionObject = { ...gridObject[actionType] };
                if (actionObject.hasOwnProperty(key)) {
                    if(key === "fieldsVisibilityRules"){
                        actionObject[key] = value;
                    }else{
                        let actionObj = { ...actionObject[key] };
                        actionObj = { ...actionObj, ...value };
                        actionObject[key] = actionObj;
                    }
                } else {
                    actionObject = { ...actionObject, [key]: value };
                }
                gridObject[actionType] = actionObject;
            } else {
                gridObject = { ...gridObject, [actionType]: { [key]: value } };
            }
            ruleElements.gridObject = gridObject;
        }
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(selectedTemplateName, 'ruleElements', ruleElements);
        //CQMasterDataStore.RuleElements.addGridObject(ruleElements);
    }

    /**
     * @param {string} key
     * @memberof GridActionsReducer
     */
    public deleteViewModel(key: string, selectedTemplateName: string, actionType: string) {
        let ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(selectedTemplateName, 'ruleElements');
        // let ruleElements = { ...CQMasterDataStore.RuleElements.FieldRuleElement };
        if (ruleElements.hasOwnProperty('gridObject')) {
            if (ruleElements.gridObject.hasOwnProperty(actionType)) {
                if (ruleElements.gridObject[actionType].hasOwnProperty(key)) {
                    let gridObject = { ...ruleElements.gridObject };
                    let actionObject = { ...gridObject[actionType] };
                    delete actionObject[key];
                    gridObject[actionType] = actionObject;
                    ruleElements.gridObject = gridObject;
                    //CQMasterDataStore.RuleElements.addGridObject(ruleElements);
                    CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(selectedTemplateName, 'ruleElements', ruleElements);
                }
            }

        }
    }
}